/* Clickfree — Memory Archive landing section behaviour
   - scroll reveal
   - before/after photo restoration slider (pointer + keyboard)
   Safe to include once per page; it initialises every .cf-page on the page. */
(function () {
  function initReveal(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cf-reveal]'));
    if (!items.length) return;
    function showAll() { items.forEach(function (el) { el.classList.add('cf-in'); }); }
    if (!('IntersectionObserver' in window) || document.visibilityState === 'hidden') {
      showAll();
      return;
    }
    // Anything already on screen shows immediately (print, screenshots, deep links).
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('cf-in');
    });
    var fired = false;
    var io = new IntersectionObserver(function (entries, obs) {
      fired = true;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cf-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    items.forEach(function (el) { io.observe(el); });
    // Safety nets: observer never delivered, or the page is being rendered hidden / printed.
    setTimeout(function () { if (!fired) showAll(); }, 1200);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') showAll();
    });
    window.addEventListener('beforeprint', showAll);
  }

  function initCompare(root) {
    var stage = root.querySelector('[data-cf-compare]');
    if (!stage) return;
    var after = stage.querySelector('.cf-compare__after');
    var line = stage.querySelector('.cf-compare__line');
    var handle = stage.querySelector('.cf-compare__handle');
    var dragging = false;

    function set(pct) {
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      line.style.left = pct + '%';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    function fromEvent(e) {
      var rect = stage.getBoundingClientRect();
      set(((e.clientX - rect.left) / rect.width) * 100);
    }

    stage.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (stage.setPointerCapture) stage.setPointerCapture(e.pointerId);
      fromEvent(e);
    });
    stage.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
      stage.addEventListener(type, function () { dragging = false; });
    });

    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(handle.getAttribute('aria-valuenow') || '50');
      if (e.key === 'ArrowLeft') { set(current - 4); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(current + 4); e.preventDefault(); }
      if (e.key === 'Home') { set(0); e.preventDefault(); }
      if (e.key === 'End') { set(100); e.preventDefault(); }
    });

    set(parseFloat(stage.getAttribute('data-cf-start') || '50'));
  }

  function initSmoothAnchors(root) {
    root.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 70;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  function collapseHeaderGap(root) {
    if (root.getAttribute('data-cf-collapse-gap') !== 'true') return;
    var wrapper = root.closest ? (root.closest('.shopify-section') || root.parentElement) : root.parentElement;
    if (!wrapper) return;

    function isEmptySpacer(node) {
      if (!node || node.nodeType !== 1) return false;
      if (node.offsetHeight === 0) return false;
      if ((node.textContent || '').trim() !== '') return false;
      return !node.querySelector('img, svg, picture, video, iframe, canvas, input, button');
    }

    // Any empty blocks rendered above this section (hidden header / announcement spacers).
    var node = wrapper.previousElementSibling;
    while (node) {
      if (isEmptySpacer(node)) node.style.display = 'none';
      node = node.previousElementSibling;
    }

    // The whole header section group, when every section inside it is hidden.
    var groups = document.querySelectorAll('.shopify-section-group-header-group, #shopify-section-group-header-group');
    Array.prototype.slice.call(groups).forEach(function (group) {
      if (group.contains(wrapper)) return;
      if (isEmptySpacer(group)) group.style.display = 'none';
    });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.cf-page')).forEach(function (root) {
      collapseHeaderGap(root);
      if (root.dataset.cfReady) return;
      root.dataset.cfReady = '1';
      root.classList.remove('cf-no-js');
      initReveal(root);
      initCompare(root);
      initSmoothAnchors(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
